import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Input
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";

@Component({
  selector: "app-modale-attesa",
  templateUrl: "./modale-attesa.component.html"
})
export class ModaleAttesaComponent implements OnInit {
  @ViewChild("templateModaleAttesa", { static: false })
  public attesaModal: TemplateRef<any>;
  public modalRef: BsModalRef;
  private config = {
    class: "modal-dialog modal-info modal-sm",
    animated: true
  };
  public completed: boolean = false;

  @Input()
  errore: boolean;

  constructor(private modalService: BsModalService) {}

  ngOnInit() {}

  public openModal() {
    this.modalRef = this.modalService.show(this.attesaModal, this.config);
  }

  public close() {
    const promise = new Promise(resolve => setTimeout(resolve, 50));
    promise.then(_ => this.modalRef.hide());
  }
}
